import { createSlice, current } from '@reduxjs/toolkit';
import {
	getWaterRightsStatusList,
	getWaterRightsStatusListQuery,
	getWaterRightsStatus,
	addNewWaterRightsStatus,
	updateWaterRightsStatus,
	deleteWaterRightsStatus,
	checkWaterRightsStatusExists,
} from './thunk';

export const initialState = {
	itemWaterRightsStatusList: [],
	itemWaterRightsStatus: null,
	isWaterRightsStatusLoading: false,
	isWaterRightsStatusSuccess: false,
	dataWaterRightsStatus: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const WaterRightsStatusSlice = createSlice({
	name: 'WaterRightsStatus',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWaterRightsStatusList.pending, state => {
			state.isLoadingList = true;
			state.isWaterRightsStatusSuccess = false;
		});

		builder.addCase(getWaterRightsStatusList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemWaterRightsStatusList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isWaterRightsStatusSuccess = true;
		});

		builder.addCase(getWaterRightsStatusList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWaterRightsStatusSuccess = false;
		});

		builder.addCase(getWaterRightsStatus.pending, state => {
			state.isWaterRightsStatusLoading = true;
			state.isWaterRightsStatusSuccess = false;
		});

		builder.addCase(getWaterRightsStatus.fulfilled, (state, action) => {
			state.itemWaterRightsStatus = action.payload;
			state.isWaterRightsStatusLoading = false;
			state.isWaterRightsStatusSuccess = true;
		});

		builder.addCase(getWaterRightsStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isWaterRightsStatusLoading = false;
			state.isWaterRightsStatusSuccess = false;
		});

		builder.addCase(addNewWaterRightsStatus.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewWaterRightsStatus.fulfilled, (state, action) => {
			state.itemWaterRightsStatusList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewWaterRightsStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateWaterRightsStatus.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateWaterRightsStatus.fulfilled, (state, action) => {
			state.itemWaterRightsStatusList = state.itemWaterRightsStatusList.map(
				waterRightsStatusList =>
					waterRightsStatusList._id.toString() === action.payload._id.toString()
						? { ...waterRightsStatusList, ...action.payload }
						: waterRightsStatusList
			);

			state.statementList = state.statementList.map(waterRightsStatusList =>
				waterRightsStatusList._id.toString() === action.payload._id.toString()
					? { ...waterRightsStatusList, ...action.payload }
					: waterRightsStatusList
			);

			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);

			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateWaterRightsStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWaterRightsStatus.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteWaterRightsStatus.fulfilled, (state, action) => {
			state.itemWaterRightsStatusList = current(state.itemWaterRightsStatusList).filter(
				item => item._id !== action.payload._id
			);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);

			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteWaterRightsStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkWaterRightsStatusExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkWaterRightsStatusExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkWaterRightsStatusExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = WaterRightsStatusSlice.actions;

export default WaterRightsStatusSlice.reducer;
